import type { Registry as Services } from '@ember/service';

export default function createAccessFlags(
  access: Services['access'],
): string[] {
  return Array.from(access.featureFlags);
}
